export default __webpack_public_path__ + "static/media/more_vertical.e9114a24.svg";